"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleValidationFieldName = void 0;
/**
 * The allowed validation field names.
 */
exports.CircleValidationFieldName = {
    FirstName: 'first_name',
    LastName: 'last_name',
    Dob: 'dob',
    Email: 'email',
    PartnerMemberId: 'partner_member_id',
    SubscriberId: 'subscriber_id',
    PolicyId: 'policy_id',
    GroupId: 'group_id',
    AlternateId: 'alternate_id',
    InviteCode: 'invite_code',
    SponsorCode: 'sponsor_code',
};
//# sourceMappingURL=circle-validation-field-name.js.map